import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Provider } from "react-redux";
import { store } from "./state/store";
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./app/query/client";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from "@vercel/speed-insights/react"

const isPrerendering = /ReactSnap/i.test(navigator.userAgent);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <HelmetProvider>
        <App />
        {!isPrerendering && <Analytics />}
        {!isPrerendering && <SpeedInsights />}
      </HelmetProvider>
    </Provider>
  </QueryClientProvider>
);

// Register the service worker so Uben stays installable as a PWA. It does
// not cache the app for offline use — a fallback page asks users to reconnect.
serviceWorkerRegistration.register();